// extracted by mini-css-extract-plugin
module.exports = {"--primary":"#0072CF","--accent":"#41AD49","--error":"#E50000","--text":"rgba(0, 0, 0, 0.87)","--alternateText":"#fff","--linkText":"#0072CF"};